import React, { useEffect } from 'react';

// A notice for this viewer that floats over the chat and never enters it. It closes on × or
// by itself after NOTICE_MS.
export const NOTICE_MS = 15000;

export default function FloatingNotice({ text, onDismiss, floating, bottom }) {
  useEffect(() => {
    if (!text) return undefined;
    const t = setTimeout(onDismiss, NOTICE_MS);
    return () => clearTimeout(t);
  }, [text, onDismiss]);
  if (!text) return null;
  return (
    <div role="status" style={{
      ...(floating ? { position: 'absolute', left: 16, right: 16, bottom, zIndex: 6 } : { margin: '4px 6px' }),
      display: 'flex', alignItems: 'flex-start', gap: 10,
      padding: '10px 12px',
      background: '#fef9c3', border: '1px solid #fde68a', borderRadius: 10,
      boxShadow: '0 4px 14px rgba(113, 63, 18, 0.12)',
      color: '#713f12', fontSize: '0.85rem', lineHeight: 1.4,
    }}>
      <span style={{ flex: 1 }}>{text}</span>
      <button type="button" aria-label="Dismiss" onClick={onDismiss} style={{
        border: 'none', background: 'transparent', color: '#713f12', cursor: 'pointer',
        fontSize: '1rem', lineHeight: 1, padding: 0,
      }}>×</button>
    </div>
  );
}
